import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Download, RefreshCw, Users } from 'lucide-react';

const MasterclassLeadsTab = ({ API_URL }) => {
  const [data, setData] = useState({ total: 0, items: [] });
  const [loading, setLoading] = useState(true);

  const fetchLeads = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/masterclass/registrations`);
      if (res.ok) setData(await res.json());
    } catch (e) { /* ignore */ }
    setLoading(false);
  };

  useEffect(() => { fetchLeads(); }, []);

  const exportCsv = () => {
    window.open(`${API_URL}/api/admin/masterclass/registrations/export`, '_blank');
  };

  return (
    <div className="space-y-6" data-testid="masterclass-leads-tab">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Users className="w-5 h-5 text-emerald-600" />
          <h2 className="text-xl font-bold text-gray-800">Masterclass Registrations</h2>
          <span className="ml-2 px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-sm font-semibold" data-testid="masterclass-total-count">
            {data.total} total
          </span>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={fetchLeads} data-testid="masterclass-refresh-btn">
            <RefreshCw className="w-4 h-4 mr-1" /> Refresh
          </Button>
          <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white" onClick={exportCsv} data-testid="masterclass-export-btn">
            <Download className="w-4 h-4 mr-1" /> Export CSV
          </Button>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-left">
              <tr>
                <th className="px-4 py-3 font-semibold">Date</th>
                <th className="px-4 py-3 font-semibold">Name</th>
                <th className="px-4 py-3 font-semibold">Phone</th>
                <th className="px-4 py-3 font-semibold">Email</th>
                <th className="px-4 py-3 font-semibold">Experience</th>
                <th className="px-4 py-3 font-semibold">Source</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading ? (
                <tr><td colSpan={6} className="px-4 py-8 text-center text-gray-400">Loading…</td></tr>
              ) : data.items.length === 0 ? (
                <tr><td colSpan={6} className="px-4 py-8 text-center text-gray-400">No registrations yet.</td></tr>
              ) : (
                data.items.map((r, i) => (
                  <tr key={r.id || i} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                      {r.created_at ? new Date(r.created_at).toLocaleString('en-IN') : '-'}
                    </td>
                    <td className="px-4 py-3 font-medium text-gray-800">{r.name}</td>
                    <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{r.phone}</td>
                    <td className="px-4 py-3 text-gray-600">{r.email}</td>
                    <td className="px-4 py-3 text-gray-600">{r.experience || '-'}</td>
                    <td className="px-4 py-3 text-gray-500">{r.source || 'direct'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MasterclassLeadsTab;
